import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'antd';
import { ENDPOINTS } from 'constants/endpoints';
import { get } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import GreaterIcon from 'assets/icons/greater-than-icon';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { COLOR } from 'constants/colors';

import './index.css';
import { redirectToOld } from '../../../__utils/common-utils';
import { TOP_FUNDS_CATEGORY } from 'constants/common-constants';
import useFlashToggler from 'hooks/use-flash-toggler';
import { useMediaQuery } from 'react-responsive';
import { CalculatorDisclaimer } from '../calculator-helper';

const TopRatedFundsSlider: React.FC = () => {

  const flash = useFlashToggler();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [topRatedFund, setTopRatedFunds] = useState<Array<any>>([]);


  const filterSpaceSlashFromString = (stringToFormat: any) => {
    if (stringToFormat) return stringToFormat.replace(/\s/g, '-').replace(/\//g, '-');
  }

  const redirectToFundsPage = (index: number) => {
    Mixpanel.track(getEventName("viewMutualFundDetail", "clicked", "calculator"));
    redirectToOld(`mutual-fund-detail/${filterSpaceSlashFromString(topRatedFund[index].schemeName)}-${filterSpaceSlashFromString(topRatedFund[index].category)}-${filterSpaceSlashFromString(topRatedFund[index].subCategory)}?schemeId=${topRatedFund[index].encryptedSchemeId}`);
  }

  const redirectToAllFundsPage = () => {
    Mixpanel.track(getEventName("exploreMoreFunds", "clicked", "calculator"));
    redirectToOld('best-performing-funds');
  }

  //Get all top rated mutual funds list
  const getTopMutualFunds = () => {
    get(ENDPOINTS.GET_TOP_MUTUAL_FUNDS, {}, true)
      .subscribe((response: AjaxResponse | AjaxError) => {
        if (response?.response) {
          const fundsArray = response.response;
          const topFundsCategory = fundsArray.filter((fund: any) =>
            fund?.tags && fund?.tags?.find((element: any) => element?.tag === TOP_FUNDS_CATEGORY.ELSS
            )
          )
          setTopRatedFunds(topFundsCategory?.slice(0, 3));
        }
      }, (error: AjaxError) => {
        flash.error("Failed to fetch top rated funds.Please try again later.");
      });
  }

  useEffect(() => {
    getTopMutualFunds();
  }, []);
  return (
    <>
      <CalculatorDisclaimer />
      <div className="top-rated-funds-wrap">
        <h2 className={isMobile ? 'font16' : 'font24'}>Explore top rated ELSS funds to invest</h2>
        <Row gutter={14}>
          {topRatedFund?.map((fund: any, index) => {
            return (
              <Col xs={24} md={8} key={index}>
                <Card bordered={false} className="card">
                  <Row>
                    <Col xs={13} md={15}>
                      <div className="fund-name-sec">
                        <h4>{fund.schemeName}</h4>
                        <span>{TOP_FUNDS_CATEGORY.ELSS}</span>
                      </div>
                    </Col>
                    <Col xs={11} md={9}>
                      <div className="fund-return-sec">
                        <span>3 yr returns</span>
                        <div className="perc">{fund?.threeYearReturn.toFixed(2)}%</div>
                        <span>As on {new Date(fund.lastUpdatedNavDate).toLocaleDateString()}</span>
                      </div>
                    </Col>
                  </Row>
                  <button onClick={() => redirectToFundsPage(index)}>Invest Now</button>
                </Card>
              </Col>
            )
          })}
        </Row>
        <div className='exploretag'>
          <a className="explore-btn" onClick={() => redirectToAllFundsPage()}>Explore more funds  <GreaterIcon color={COLOR.BLACK} /></a>
        </div>
      </div>
    </>
  )
}

export default TopRatedFundsSlider;